export default "__VITE_ASSET__D752c1dx__"